import http from 'plugins/axios';

export default {
  //返佣列表
 
  reqList({page,size,coinType,startTime,endTime,userId}) {
    return http.get({
      url: `/la/admin/invitation/reward/list?page=${page}&size=${size}&coinType=${coinType}&startTime=${startTime}&endTime=${endTime}&userId=${userId}`,

    });
  },
  exportExcel({  coinType, startTime, endTime,userId }){
    return http.get({
        url: `/la/admin/invitation/reward/list/excel?coinType=${coinType}&userId=${userId}&startTime=${startTime}&endTime=${endTime}`,
        responseType:'blob',
    })
  },
  getAllCoins() {
    return http.get({
      url: '/la/admin/coin/coin-list'
    });
  }
};
